export type GovernorStatus =
  | "FOUNDATION"
  | "ACTIVE"
  | "RUNTIME"
  | "VERIFICATION"
  | "CONSOLIDATE"
  | "DEPRECATED";

export interface GovernorInventoryItem {
  id: string;
  domain: string;
  status: GovernorStatus;
  maturity: number;
  notes: string;
}

export const GOVERNOR_MASTER_INVENTORY: GovernorInventoryItem[] = [
  {
    id: "executive",
    domain: "Executive Governor",
    status: "ACTIVE",
    maturity: 5,
    notes: "Executive orchestration, dashboard, runtime and scoreboards detected."
  },
  {
    id: "calls",
    domain: "Calls Governor",
    status: "RUNTIME",
    maturity: 4,
    notes: "Runtime evidence and WebRTC instrumentation detected."
  },
  {
    id: "tree",
    domain: "Tree Governor",
    status: "ACTIVE",
    maturity: 4,
    notes: "Tree verification and integrity components detected."
  },
  {
    id: "membership",
    domain: "Membership Governor",
    status: "ACTIVE",
    maturity: 3,
    notes: "Membership policies and governance detected."
  },
  {
    id: "business",
    domain: "Business Governor",
    status: "ACTIVE",
    maturity: 3,
    notes: "Billing and business governance detected."
  },
  {
    id: "kinsspace",
    domain: "KinsSpace Governor",
    status: "FOUNDATION",
    maturity: 2,
    notes: "Needs runtime activation and verification."
  },
  {
    id: "gude",
    domain: "GUDE",
    status: "ACTIVE",
    maturity: 5,
    notes: "Multiple GUDE runtime and governance modules detected."
  }
];
